import { createResourceQuery } from '@faro/resource-query';
import { Study } from '@faro/study-designer-model';
import { ServiceContextValue } from '../../../context';

interface StudyDefinitionNameEditModalDataQuery {
    id: string;
}
interface StudyDefinitionNameEditModalData {
    study: Study;
}
export const useStudyDefinitionNameEditModalData = createResourceQuery<
    StudyDefinitionNameEditModalData,
    StudyDefinitionNameEditModalDataQuery,
    ServiceContextValue
>({
    resolve: async ({ query: { id }, context: { studyService } }) => ({
        study: await studyService.get({ id }),
    }),
    id: 'StudyDefinitionNameEditModalData',
});
